<template>
  <page
    v-if="loaded"
    :custom-style="{
      backgroundColor: '#fff',
      minHeight: '100vh'
    }"
  >
    <empty
      v-if="configList.length === 0"
      :desc="'暂无配置'"
      :type="1"
      :img="'Empty'"
      class="empty-box"
    ></empty>
    <div v-else class="config-box">
      <div class="config-content">
        <div class="config-title">请选择以下配送时间段的商品</div>
        <div
          v-for="item in configList"
          :key="item.value"
          class="config-item"
          @click="selectItem(item)"
        >
          <div class="select-operate">
            <IconFont
              :name="
                selectValue == item.value
                  ? 'xuankuang-gouxuan'
                  : 'xuankuang-weixuanzhong'
              "
              :color="selectValue == item.value ? '#15bb5c' : '#ccc'"
              size="24px"
            ></IconFont>
          </div>
          <div class="info">{{ item.label }}</div>
        </div>
        <div class="tip-content">
          <p class="tip">
            不限制：全天可下单时段，美菜配送商品，若支持多批次配送，默认按最早批次配送；
          </p>
          <p class="tip">
            凌晨达：<span class="time">{{ lcsEndTime }}</span
            >前可下单时段，美菜配送商品，若支持多批次配送，默认按凌晨批次配送；
          </p>
          <p class="tip">
            上午达：全天可下单时段，美菜配送商品，若支持多批次配送，默认按上午批次配送；
          </p>
        </div>
      </div>

      <div class="footer">
        <div class="submit-btn" @click.prevent="submitConfirm">提交</div>
      </div>
    </div>
  </page>
</template>
<script>
import { navBar } from '@/utils/native_interactions/native_bar'
import { THEME_COLOR } from '@/defines/environment/config'
import { API } from '@/api'
import Empty from '@/common/layout/empty/index'
export default {
  components: {
    Empty
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      navBar.setTitle({
        text: '商品配置'
      })
      vm.getConfig()
    })
  },
  data() {
    return {
      configList: [],
      selectValue: '',
      loaded: false,
      lcsEndTime: ''
    }
  },
  methods: {
    async getConfig() {
      this.$Loading()
      const res = await API.account.userConfig()
      const configData = await API.account.configGetByKey({ key: 'lcsEndTime' })
      this.lcsEndTime = configData?.lcsEndTime || ''
      this.configList = res.user_except_batch || []

      const selectItem = this.configList.find(item => item.selected)
      this.selectValue = selectItem?.value || ''
      this.loaded = true
      this.$Loading.hide()
    },
    selectItem(item) {
      const value = item.value
      if (this.selectValue === value) {
        return
      }
      this.selectValue = value
    },
    goBack() {
      this.$back()
    },
    async submitConfirm() {
      if (!this.selectValue) {
        this.$toast({
          message: '请选择商品配置',
          duration: '2000'
        })
      }

      const params = {
        key: 'user_except_batch',
        value: this.selectValue
      }

      try {
        await API.account.submitConfig(params)
        const lcsEndTime = this.lcsEndTime

        // eslint-disable-next-line eqeqeq
        if (this.selectValue == 13) {
          const msg = `提交成功，凌晨达商品请于<span style="color: red">${lcsEndTime}</span>前下单，超时后，仅支持上午达`
          this.$dialog
            .alert({
              confirmButtonText: '知道了',
              message: msg,
              confirmButtonColor: THEME_COLOR
            })
            .then(() => {
              this.goBack()
            })
        } else {
          const msg = '提交成功'
          this.$toast({
            message: msg,
            onClose: () => {
              this.goBack()
            }
          })
        }
      } catch (error) {
        this.$catch(error)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.config-title {
  margin: 0 0.32rem /* 16/50 */;
  padding-top: 0.24rem /* 12/50 */;
  @include text(0.32rem /* 16/50 */, #262626, true);
}
.config-box {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .config-content {
    flex: auto;
  }
}
.config-item {
  @include flex-row-center;
  margin: 0 0.32rem /* 16/50 */;
  padding-top: 0.32rem;
  /* 15/50 */
  background: #fff;
  box-sizing: border-box;
  border-bottom: 1px solid #f6f6f6;

  .info {
    flex: auto;
    width: 0;
    margin-left: 0.16rem /* 8/50 */;
    @include text(0.32rem /* 16/50 */, #262626);
  }
}
.tip-content {
  padding: 0 0.32rem /* 16/50 */;
  background-color: #f5f5f5;
  border-radius: 0.24rem /* 12/50 */;
  margin: 0.48rem /* 24/50 */ 0.32rem /* 16/50 */;
  .tip {
    padding: 0.24rem 0;
    line-height: 0.6rem /* 30/50 */;
    @include text(0.28rem /* 14/50 */, #8c8c8c);
    .time {
      color: #f03100;
    }
  }
}
.footer {
  width: 100%;
  padding: 20px;
  padding-top: 30px;
  box-sizing: border-box;
  .submit-btn {
    height: 0.88rem /* 44/50 */;
    background-color: #0daf52;
    border-radius: 0.8rem /* 40/50 */;
    color: #fff;
    @include flex-row-center;
  }
}
</style>
